__turbopack_context__.v({
  "circle-button": "styles-module-scss-module__J0LJfW__circle-button",
  "header": "styles-module-scss-module__J0LJfW__header",
  "quotation": "styles-module-scss-module__J0LJfW__quotation",
  "quote-container": "styles-module-scss-module__J0LJfW__quote-container",
  "underline-and-title-container": "styles-module-scss-module__J0LJfW__underline-and-title-container",
  "user-title": "styles-module-scss-module__J0LJfW__user-title",
});
